import { Component, OnInit, OnDestroy, Output, EventEmitter, ElementRef, ViewChild, Renderer2 } from '@angular/core';
import { NotificationService } from '../notification.service';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-notification-bell',
  templateUrl: './notification-bell.component.html',
  styleUrls: ['./notification-bell.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class NotificationBellComponent implements OnInit, OnDestroy {
  @Output() toggleNotifications = new EventEmitter<void>();
  @ViewChild('bellButton') bellButton!: ElementRef;
  
  unreadCount = 0;
  private subscriptions: Subscription[] = [];
  private previousUnreadCount = 0;
  
  constructor(
    private notificationService: NotificationService,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    // Subscribe to unread count updates
    this.subscriptions.push(
      this.notificationService.unreadCount$.subscribe(count => {
        // Animate bell when count increases
        if (count > this.previousUnreadCount) {
          this.animateBellOnNewNotification();
        }
        
        this.previousUnreadCount = count;
        this.unreadCount = count;
      })
    );
  }
  
  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
  
  // Trigger toggle notifications in parent component
  onToggleNotifications(event: Event): void {
    event.stopPropagation();
    this.toggleNotifications.emit();
  }
  
  // Animate the bell when a new notification arrives
  private animateBellOnNewNotification(): void {
    if (this.bellButton) {
      const bellIcon = this.bellButton.nativeElement.querySelector('svg');
      if (bellIcon) {
        this.renderer.addClass(bellIcon, 'animate-bell');
        
        setTimeout(() => {
          this.renderer.removeClass(bellIcon, 'animate-bell');
        }, 1000);
      }
    }
  }
} 